import Fingerprint2 from 'fingerprintjs2';
import axios from 'axios';
import { browserWpkReport } from './utils/wpk';

import { isWeb } from './utils/env';
/**
 * https://g.alicdn.com/??AWSC/AWSC/awsc.js,sd/baxia-entry/baxiaCommon.js
 * baxiajs业务 主动引入
 * window['__baxia_env'] 需要首先注入 initBaxia需要用到
 * 外链的时候url需要有参数 env、businessScene
 * npm引入的时候
 */
////////////////////////////////////////////////////////////////////////////////////////////////////////
// 需要尽可能的提早执行initBaxia
const initBaxia = () => {
  if (isWeb) {
    return new Promise(function (resolve) {
      // @ts-ignore 初始化后不再处理
      if (window['__baxia_baxiaLoaded']) {
        resolve(null);
      }
      // @ts-ignore
      if (window?.baxiaCommon?.init) {
        // @ts-ignore
        window.baxiaCommon.init({
          checkApiPath: function () {
            return true;
          },
          uabOptions: { location: 'cn' },
        });
      }
      // @ts-ignore
      if (window?.AWSC?.use) {
        var umidToken = 'defaultToken1_um_not_loaded@@' + location.href + '@@' + new Date().getTime();
        // @ts-ignore
        window.AWSC.use('um', function (state, umModule) {
          if (state === 'loaded') {
            // @ts-ignore
            window['__baxia_baxiaLoaded'] = true;
            resolve(null);
            umidToken = 'defaultToken3_init_callback_not_called@@' + location.href + '@@' + new Date().getTime();
            umModule.init(
              {
                appName:
                  // @ts-ignore baxia 分配应用名称 @zihe
                  window['__baxia_env'] === 'prod'
                    ? 'wagbridgead-sm-nginx-quarkpc-security-calibration-time-web'
                    : 'aserver__pre__-sm-search-frontend-quarkpc-security-time-web',
                serviceLocation: 'cn', // 默认上报到中国，可不填。如需要上报到其他区域，参考下文参数说明。
              },

              (initState: string, result: any) => {
                if (initState === 'success') {
                  umidToken = result.tn;
                } else {
                  umidToken =
                    'defaultToken4_init_failed with ' + initState + '@@' + location.href + '@@' + new Date().getTime();
                }
              },
            );
          } else {
            umidToken = 'defaultToken2_load_failed with ' + state + '@@' + location.href + '@@' + new Date().getTime();
          }
        });

        if (umidToken.indexOf('defaultToken1') !== -1 || umidToken.indexOf('defaultToken3') !== -1) {
          setTimeout(function () {
            // @ts-ignore 在这里再将umidToken跟随业务请求发送出去，
            window.umidToken = umidToken;
          }, 1000);
        }
      }
    });
  } else {
    return new Promise(function (resolve) {
      resolve(null);
    });
  }
};

if (isWeb) {
  const script = document.currentScript;
  // 从 script.src 获取完整的 URL
  // @ts-ignore
  const scriptUrl = script?.src;
  if (scriptUrl) {
    // 创建一个 URL 对象
    const url = new URL(scriptUrl);
    // 使用 URLSearchParams 获取参数
    const params = new URLSearchParams(url.search);
    // 获取特定参数的值
    const env = params.get('env'); // 替换 'yourParamKey' 为你想要获取的参数名
    console.log('输出参数值:paramValue', env); // 输出参数值
    // @ts-ignore
    if (window['__baxia_env'] === undefined) {
      // 没有值才会附值
      // @ts-ignore
      window['__baxia_env'] = env === 'prod' ? 'prod' : 'pre';
    }
  } else {
    console.log('输出参数值:scriptUrl', scriptUrl); // 输出参数值
  }
}
// 加载就执行了
const initBaxiaPromise = initBaxia();
////////////////////////////////////////////////////////////////////////////////////////////////////////
export class BrowserCrypto {
  constructor({ businessScene, envType, ve = '1.0.0' }: any, showLog = false) {
    // @ts-ignore
    this.businessScene = businessScene;
    // @ts-ignore
    this.envType = envType;
    // @ts-ignore
    this.ve = ve;
    // @ts-ignore
    this.token = null;
    // @ts-ignore
    this.showLog = showLog;
    // @ts-ignore
    this.endOutEnv = {
      pre: 'https://pre-ext.quark.cn/security',
      local: 'https://pre-ext.quark.cn/security',
      prod: 'https://ext.quark.cn/security',
      publish: 'https://ext.quark.cn/security',
    };
    // @ts-ignore
    window['__baxia_env'] = envType === 'prod' ? 'prod' : 'pre';
    initBaxia();
  }

  async browserFingerprint() {
    const data = await this.createFingerprint();
    return data;
  }

  async createFingerprint() {
    await new Promise((resolve) => {
      Fingerprint2.get((components) => {
        const params = {};
        components.forEach((item) => {
          // @ts-ignore
          params[item.key] = item.value;
        });
        const values = components.map((component) => component.value);
        const murmur = Fingerprint2.x64hash128(values.join(''), 31);
        localStorage.setItem('browserInfo', JSON.stringify({ murmur, ...params }));
        // @ts-ignore
        window.browserInfo = { murmur, ...params };
        // @ts-ignore
        resolve();
      });
    });
    // window?.um.getStatus() ? 为什么保障这个有值，是不是前置保障
    const data = await this.registerUser();
    return data;
  }

  async registerUser() {
    // @ts-ignore
    const browserInfo = window.browserInfo || JSON.parse(localStorage.getItem('browserInfo'));
    const { data } = await axios({
      // @ts-ignore
      url: `${this.endOutEnv[this.envType]}/external/access/register`,
      method: 'post',
      headers: {
        'bx-eo-clt-sftcnt': 100,
      },
      data: {
        fingerprint: browserInfo.murmur,
        // @ts-ignore
        businessScene: this.businessScene,
        screenResolution: `${browserInfo.screenResolution[0]}x${browserInfo.screenResolution[1]}`,
        timezoneOffset: browserInfo.timezone,
        cookieEnabled: false,
        localStorageEnabled: true,
        fontList: browserInfo.fonts,
        pluginList: browserInfo.plugins,
        language: [browserInfo.language],
      },
    });
    if (JSON.stringify(data.data) !== '{}') {
      localStorage.setItem('userToken', JSON.stringify(data.data));
      return data;
    }
  }

  async refreshToken() {
    // @ts-ignore
    const userToken = JSON.parse(localStorage.getItem('userToken'));
    const response = await axios.get(
      // @ts-ignore
      `${this.endOutEnv[this.envType]}/external/access/refresh?businessScene=${this.businessScene}`,
      {
        headers: {
          'bx-eo-clt-sftcnt': 100,
          'eo-clt-dvidn': userToken['eo-clt-dvidn'],
          'eo-clt-actkn': userToken['eo-clt-actkn'],
          'eo-clt-sftcnt': userToken['eo-clt-sftcnt'],
        },
      },
    );
    return response.data;
  }

  async verifyTime() {
    // @ts-ignore
    const response = await axios.get(`${this.endOutEnv[this.envType]}/calibration/time`);
    return response.data?.data?.millisTimeStamp;
  }

  async crateSignature(
    dvidn: string,
    ve: string,
    kp: string,
    requestParams: string,
    saltKey: string,
    timeStamp: string,
  ) {
    const dataToSign = dvidn + ve + kp + requestParams;
    const secretKey = `${saltKey}:${timeStamp}`;
    const enc = new TextEncoder();
    const keyBuffer = enc.encode(secretKey);
    const dataBuffer = enc.encode(dataToSign);
    const cryptoKey = await crypto.subtle.importKey('raw', keyBuffer, { name: 'HMAC', hash: 'SHA-256' }, false, [
      'sign',
    ]);
    const signatureBuffer = await crypto.subtle.sign('HMAC', cryptoKey, dataBuffer);
    const signatureArray: any = new Uint8Array(signatureBuffer);
    const signatureBase64 = btoa(String.fromCharCode.apply(null, signatureArray));
    return signatureBase64;
  }

  async confusionReverse(originsigFactor: string, sgs: string) {
    const sigFactor = window.atob(`${originsigFactor}`);
    const secretKey = sigFactor.substring(0, 32);
    const length = sigFactor.substring(32);
    const keyBuffer = new TextEncoder().encode(secretKey);
    const iv = new TextEncoder().encode(sigFactor.substring(0, 16));
    const cryptoKey = await crypto.subtle.importKey('raw', keyBuffer, { name: 'AES-CBC' }, false, ['decrypt']);
    const sgsBuffer = this.base64ToArrayBuffer(sgs);
    const decodeContent = await crypto.subtle.decrypt({ name: 'AES-CBC', iv }, cryptoKey, sgsBuffer);
    const sgsStr = new TextDecoder().decode(decodeContent);
    const map = new Map();
    const lenList = [];
    for (let i = 0; i < 4; i++) {
      const len = parseInt(length.substring(i * 2, i * 2 + 2));
      map.set(len, i);
      lenList.push(len);
    }
    lenList.sort((a, b) => a - b);
    const splitRes = this.splitStr(sgsStr, lenList);
    const finalRes = [];
    const count = sgsStr.length / 32;
    for (const str of splitRes) {
      finalRes[map.get(str.length / count)] = str;
    }
    return { data: JSON.parse(finalRes.join('').trimEnd()) };
  }

  splitStr(s: string, lenList: any) {
    const res = [];
    let sum = 0;
    for (const len of lenList) {
      const realLen = Math.floor(s.length / 32) * len;
      const str = s.substring(sum, sum + realLen);
      res.push(str);
      sum += realLen;
    }
    return res;
  }

  base64ToArrayBuffer(base64: string) {
    const binaryString = atob(`${base64}`);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  async readyReq(key: string, val: string, ve = '1.0.0') {
    const startTime = Date.now();
    await initBaxiaPromise.then((res) => res);
    // @ts-ignore
    this.showLog && console.log('initBaxiaPromise:耗时', Date.now() - startTime);
    // @ts-ignore
    this.token = JSON.parse(localStorage.getItem('userToken')) || null;

    browserWpkReport('readyReq', {
      c1: key,
      c2: val,
      c3: Date.now() - startTime, //initBaxiaPromise:耗时
      // @ts-ignore
      w_bl1: this.token,
    });

    let headers = {};
    // @ts-ignore
    let _token = this.token;
    if (!_token) {
      const resToken = await this.browserFingerprint();
      if (resToken?.data) {
        _token = resToken.data;
      }
    }
    headers = await this.reuseHandel(_token, key, val, ve);
    return headers;
  }

  async reuseHandel(userToken: any, key: string, val: string, ve = '1.0.0') {
    let _token = userToken;
    // const time = await this.verifyTime();
    const time = Date.now();
    // 必须需要刷新了
    if (
      (time && Number(time) <= Number(userToken['eo-clt-actkn-dl']) * 1000) ||
      userToken['eo-clt-bacsft'].length <= 1
    ) {
      const res = await this.refreshToken();
      _token = JSON.parse(JSON.stringify(res?.data));
    } else {
      // 移步更新
      if (userToken['eo-clt-bacsft'].length <= 5) {
        setTimeout(() => {
          this.refreshToken().then((res) => {
            if (res) {
              const __token = JSON.parse(JSON.stringify(res.data));
              localStorage.setItem('userToken', JSON.stringify(__token));
              // @ts-ignore
              this.token = __token;
            }
          });
        }, 1000);
      }
    }
    let bacsft = _token['eo-clt-bacsft'].shift();
    // @ts-ignore
    this.token = _token;
    localStorage.setItem('userToken', JSON.stringify(_token));
    const headers = await this.callback(key, ve, val, bacsft, time, _token);
    return headers;
  }

  async callback(key: string, ve: string, val: string, bacsft: string, time: string, userToken: any) {
    const sign = await this.crateSignature(userToken['eo-clt-dvidn'], ve, '', val, bacsft, time);
    return {
      'clt-acs-sign': sign,
      'clt-acs-reqt': time,
      'clt-acs-request-params': key,
      'eo-clt-acs-kp': '',
      'eo-clt-dvidn': userToken['eo-clt-dvidn'],
      'eo-clt-actkn': userToken['eo-clt-actkn'],
      'eo-clt-snver': userToken['eo-clt-snver'],
      'eo-clt-sacsft': bacsft,
      'eo-clt-acs-ve': ve,
      'clt-acs-caer': 'vrad',
    };
  }
}
////////////////////////////////////////////////////////////////////////////////////////////////////////
export const loadScript = (src: string) => {
  return new Promise(function (resolve, reject) {
    // @ts-ignore
    if (window?.browserCrypto) {
      resolve(null);
    } else {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.onload = function () {
        resolve(null);
      };
      script.onerror = function () {
        reject();
      };
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    }
  });
};
